import pro1 from "../assets/project1.png"
import pro2 from "../assets/project2.png"
import pro3 from "../assets/project3.png"
import pro4 from "../assets/project4.png"

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Amazon Cloned Web",
        text: "Successfully replicated the Amazon website using HTML, CSS, and JavaScript. This project involved meticulous attention to detail to recreate the layout, design, and functionality of the popular e-commerce platform. 🛍️",
        view: "https://amazon-cloned-gamma.vercel.app/index.html",
        source: "https://github.com/pedroolayemi/amazon-cloned"
    },

    {
        imgsrc: pro2,
        title: "Weather App",
        text: "Developed a dynamic weather application using ReactJS, integrating with a weather API to provide real-time updates on weather conditions. The user-friendly interface allows users to easily check the weather for any location. 🌐",
        view: "https://pedroolayemi.github.io/weatherwebapp/",
        source: "https://github.com/pedroolayemi/weatherwebapp.git"
    },

    {
        imgsrc: pro3,
        title: "To-Do-List",
        text: "Developed a task management application with HTML, CSS, and JavaScript. This todo list allows users to add, delete, and mark tasks as complete, providing a simple yet effective solution for organizing daily activities. ✅",
        view: "https://pedroolayemi.github.io/todlist2/",
        source: "https://github.com/pedroolayemi/todlist2.git"
    },

    {
        imgsrc: pro4,
        title: "Rock , Paper , Scissors",
        text: "Dive into the world of strategic decision-making with the Rock, Paper, Scissors game—a digital masterpiece crafted using HTML, CSS, and JavaScript. This interactive experience brings the classic game to life, offering an engaging platform for friendly duels and spontaneous fun.",
        view: "https://pedroolayemi.github.io/rock-paper-scissors/",
        source: "https://github.com/pedroolayemi/rock-paper-scissors.git"
    }
]

export default ProjectCardData;